import React, { useCallback, useMemo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

const AttributeTouchSelection = ({ formData, setFormData, attributeOptions, attributeGraphTouchOptions, handleAttributeTouch, valueOptionsAttribute }) => {
    const attributeTouchOptions = useMemo(() => (
        [{ value: 'all', label: 'Select All' }, ...(valueOptionsAttribute?.map(attr => ({ value: attr.value, label: attr.label })) || [])]
    ), [valueOptionsAttribute]);

    const handleSelectChange = useCallback((selectedOptions) => {
        const isSelectAll = selectedOptions.some(option => option.value === 'all');
        if (isSelectAll) {
            setFormData(prev => ({
                ...prev,
                attributeTouch: {
                    ...prev.attributeTouch,
                    value: attributeTouchOptions.slice(1).map(option => option.value)
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                attributeTouch: {
                    ...prev.attributeTouch,
                    value: selectedOptions.map(option => option.value)
                }
            }));
        }
    }, [attributeTouchOptions, setFormData]);

    const handleBlockedSheetChange = (e) => {
        const isBlockedSheetTrue = e.target.value === "true";
        setFormData(prev => ({
            ...prev,
            attributeTouch: {
                ...prev.attributeTouch,
                blockedSheet: isBlockedSheetTrue
            }
        }));
    };
    const handleColumnChange = (e) => {
        const selectedAttribute = e.target.value;

        setFormData(prev => ({
            ...prev,
            attributeTouch: {
                ...prev.attributeTouch,
                name: selectedAttribute
            }
        }));

        handleAttributeTouch(selectedAttribute);
    };
    const handleMetricChoiceChange = (e) => {
        setFormData(prev => ({
            ...prev,
            attributeTouch: {
                ...prev.attributeTouch,
                metricChoice: Number(e.target.value),
            },
        }));
    };
    return (
        <div className="mt-3">
            <p className="form-label text-secondary pb-2">Select Event Columns to Show in Attribute Touch Graph</p>
            <div className="px-2">
                <Row className="border py-2 gy-2">
                    <Col sm={12}>
                        <Form.Group controlId="formFtdSheet">
                            <Form.Label className="text-secondary">Used Blocked Installs Sheet</Form.Label>
                            <Form.Select
                                as="select"
                                name="ftdSheet"
                                value={formData?.attributeTouch.blockedSheet ? 'true' : 'false'}
                                onChange={handleBlockedSheetChange}
                            >
                                <option value="true">True</option>
                                <option value="false">False</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group controlId={`Attr label`}>
                            <Form.Label className="text-secondary mb-0">Label</Form.Label>
                            <Form.Control
                                type="text"
                                name={`Attr-label`}
                                value={formData?.attributeTouch?.label}
                                onChange={(e) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        attributeTouch: {
                                            ...prev.attributeTouch,
                                            label: e.target.value
                                        }
                                    }));
                                }}
                            />
                        </Form.Group>
                    </Col>
                    {formData?.attributeTouch?.blockedSheet ? (
                        <>
                            <Col sm={6}>
                                <Form.Group controlId="formAttribute">
                                    <Form.Label className="text-secondary mb-0">Select Column name</Form.Label>
                                    <Form.Select value={formData?.attributeTouch?.name} onChange={handleColumnChange}>
                                        <option value="">Select Column</option>
                                        {attributeGraphTouchOptions?.map(attr => (
                                            <option key={attr.value} value={attr.value}>{attr.label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId="formValueAttribute">
                                    <Form.Label className="text-secondary mb-0">Select Column value</Form.Label>
                                    <Form.Select value={formData?.attributeTouch?.blockedSheetValue}
                                        onChange={(e) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                attributeTouch: {
                                                    ...prev.attributeTouch,
                                                    blockedSheetValue: e.target.value
                                                }
                                            }));
                                        }}
                                        disabled={!formData?.attributeTouch?.name}
                                    >
                                        <option value="">Select Value</option>
                                        {attributeTouchOptions?.map(val => (
                                            <option key={val.value} value={val.value}>{val.label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId={`selectOption-attribute`}>
                                    <Form.Label className="text-secondary mb-0">Attribute Option</Form.Label>
                                    <Form.Select
                                        value={formData?.attributeTouch?.blockedSheetSelect}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            attributeTouch: {
                                                ...prev.attributeTouch,
                                                blockedSheetSelect: e.target.value
                                            }
                                        }))}>
                                        <option value="count">Count</option>
                                        <option value="sum">Sum</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Form.Group controlId="formMetricChoice">
                                <Form.Label className="text-secondary">Metric Choice</Form.Label>
                                <Form.Select
                                    name="metricChoice"
                                    value={formData?.attributeTouch.metricChoice || 2}
                                    onChange={handleMetricChoiceChange}
                                >
                                    <option value="1">Metric 1</option>
                                    <option value="2">Metric 2</option>
                                    <option value="3">Metric 3</option>
                                    <option value="4">Metric 4</option>
                                </Form.Select>
                            </Form.Group>
                        </>
                    ) : (
                        <>
                            <Col sm={6}>
                                <Form.Group controlId="formAttribute">
                                    <Form.Label className="text-secondary mb-0">Select Column name</Form.Label>
                                    <Form.Select value={formData?.attributeTouch?.name} onChange={handleColumnChange}>
                                        <option value="">Select Column</option>
                                        {attributeOptions.map(attr => (
                                            <option key={attr.value} value={attr.value}>{attr.label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId="formValue">
                                    <Form.Label className="text-secondary mb-0">Select Column value</Form.Label>
                                    <Select
                                        isMulti
                                        options={attributeTouchOptions}
                                        value={attributeTouchOptions?.filter(option => formData?.attributeTouch?.value?.includes(option?.value))}
                                        onChange={selectedOptions => handleSelectChange(selectedOptions)}
                                        closeMenuOnSelect={false}
                                        aria-label="Attribute Touch Selection"
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    )}
                </Row>
            </div>
        </div>
    );
};

export default AttributeTouchSelection;
